import { api } from '@/api/index'
export const sendMetrics = (data) => {
  return api.post('/metrics', data)
}
